import { IActionResultSectionProps } from "components/actions-common/action-result-section/action-result-section.props";
import { ITableColumn } from "@interfaces/common.interfaces";
import ActionResultSection from "components/actions-common/action-result-section/action-result-section";

const cols: Array<ITableColumn<any>> = [
    { key: "displayName", label: "Display name", showInGrid: true, showInExport: true, minWidth: 100 },
    { key: "upn", label: "Upn", showInGrid: true, showInExport: true },
];

export default function RemoveGuestUsersAction() {

    const sectionProps: IActionResultSectionProps<any> = {
        columns: cols,
    }

    return (
        <ActionResultSection {...sectionProps} />
    );
}